import React from 'react';

// Types
import { Icon as IconType } from '../../../types/icon';
import { Measurements } from '../../../types/measurements';

// Utils
import { getMeasurementBySize } from '../../../utils/icon';

// Component
import Icon from '../Icon/Icon';

const IconSave: React.FC<IconType> = ({
  size,
  inverse,
  onClick,
  width,
  height,
  fill,
  iconClassName,
}) => {

  const defaultMeasurements: Measurements = {
    height: 15,
    width: 15,
  }

  const measurements = size ? getMeasurementBySize(size) : defaultMeasurements;

  return (
    <Icon inverse={inverse} onClick={onClick} className={iconClassName} classNameIconType="c-icon-save">
      <svg width={width || measurements.width} height={height || measurements.height} className="c-icon-save_svg fill-current" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M3.10345 14.0506V8.59177C3.10345 8.30696 3.36207 8.11709 3.62069 8.11709H11.3793C11.6379 8.11709 11.8966 8.35443 11.8966 8.59177V14.0506H13.2931C13.7069 14.0506 13.9655 13.6709 13.9655 13.3386V4.55696L10.3966 0.949367H10.0345V3.98734C10.0345 4.22468 9.77586 4.46203 9.51724 4.46203H3.67241C3.36207 4.46203 3.10345 4.22468 3.10345 3.98734V0.949367H1.7069C1.2931 0.949367 1.03448 1.32911 1.03448 1.66139V13.3386C1.03448 13.6709 1.2931 14.0506 1.7069 14.0506H3.10345ZM10.8621 14.0506V9.06646H4.13793V14.0506H10.8621ZM1.7069 0C4.65517 0 7.65517 0 10.6034 0C10.7586 0 10.9138 0.0474684 11.0172 0.189873L14.8448 4.03481C14.9483 4.12975 15 4.27215 15 4.36709V13.3386C15 14.193 14.2759 15 13.2931 15H1.7069C0.724138 15 0 14.193 0 13.3386V1.66139C0 0.806962 0.724138 0 1.7069 0ZM9 0.949367H4.13793V3.51266H9V0.949367Z" fill={fill || 'inherit'} />
      </svg>

    </Icon>
  );
};

export default IconSave;
